import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import UeberUns from "../pages/ueber-uns/page";
import Leistungen from "../pages/leistungen/page";
import Qualitaet from "../pages/qualitaet/page";
import Kontakt from "../pages/kontakt/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/ueber-uns",
    element: <UeberUns />,
  },
  {
    path: "/leistungen",
    element: <Leistungen />,
  },
  {
    path: "/qualitaet",
    element: <Qualitaet />,
  },
  {
    path: "/kontakt",
    element: <Kontakt />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;